/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Status of a wallet.
 *
 * @remarks
 *   - `active`: The wallet is available for use and has an enabled payment method.
 *   - `closed`: The wallet is no longer active and the corresponding payment method has been disabled.
 */
export const WalletStatus = {
  Active: "active",
  Closed: "closed",
} as const;
/**
 * Status of a wallet.
 *
 * @remarks
 *   - `active`: The wallet is available for use and has an enabled payment method.
 *   - `closed`: The wallet is no longer active and the corresponding payment method has been disabled.
 */
export type WalletStatus = ClosedEnum<typeof WalletStatus>;

/** @internal */
export const WalletStatus$inboundSchema: z.ZodNativeEnum<typeof WalletStatus> =
  z.nativeEnum(WalletStatus);
/** @internal */
export const WalletStatus$outboundSchema: z.ZodNativeEnum<typeof WalletStatus> =
  WalletStatus$inboundSchema;
